/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllInspectorsQuery } from '../../models/get-all-inspectors-query';
import { GetAllInspectorsQueryResult } from '../../models/get-all-inspectors-query-result';

export interface ApiPlanGetAllInspectorsPost$Plain$Params {
      body?: GetAllInspectorsQuery
}

export function apiPlanGetAllInspectorsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanGetAllInspectorsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllInspectorsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanGetAllInspectorsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllInspectorsQueryResult>;
    })
  );
}

apiPlanGetAllInspectorsPost$Plain.PATH = '/api/Plan/GetAllInspectors';
